/**
 * Spawn / difficulty scaling while the host reports backend enrichment progress.
 * @param {{ current?: number, total?: number } | null | undefined} progress
 * @param {{ badChance: number }} settings
 */
export function getEnrichmentPace(progress, settings) {
    const total = Math.max(0, Number(progress?.total) || 0);
    const current = Math.max(0, Number(progress?.current) || 0);
    // Floor ratio so enriching at 0/N still spawns cards (avoid multi-minute gaps).
    const rawRatio = total > 0 ? current / total : 0;
    const ratio = total > 0 ? Math.min(1, Math.max(0.28, rawRatio)) : 0;

    return {
        ratio,
        /** Higher = more spawns; keep near 1.0 for a moderate wait-minigame pace. */
        spawnIntensity: 0.52 + ratio * 0.18,
        badChance: settings.badChance * (0.85 + ratio * 0.08),
        motionScale: 0.72 + ratio * 0.1,
        rampElapsedSeconds: 10 + ratio * 10,
    };
}

export function hasEnrichmentProgress(progress) {
    const total = Number(progress?.total) || 0;
    return total > 0;
}
